import { render, staticRenderFns } from "./UserPicker.vue?vue&type=template&id=3a449e14&scoped=true"
import script from "./UserPicker.vue?vue&type=script&lang=js"
export * from "./UserPicker.vue?vue&type=script&lang=js"
import style0 from "./UserPicker.vue?vue&type=style&index=0&id=3a449e14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a449e14",
  null
  
)

export default component.exports